import React, { Component } from "react";

import SubscribeButton from "../../../components/Library/SubscribeButton";

import styles from "./Subscribing.css";

class Subscribing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
    };
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { subscription } = this.props;
    if (!subscription) return null;

    return (
      <div>
        <div className={styles.content}>
          <div className={styles.text}>
            Great choice. Enter your email to subscribe to <strong>{subscription.name}</strong>.
          </div>
          <input
            name="email"
            aria-label="Enter Your Email Address"
            className={styles.input}
            placeholder="Your Email Address"
            value={this.state.email}
            onChange={this.onChange}
          />
        </div>
        <SubscribeButton
          className={styles.subscribe}
          disabled={this.state.email === ""}
          onClickSubscribe={() => this.props.onSubscribe(this.state.email)}>
          Submit
        </SubscribeButton>
      </div>
    );
  }
}

export default Subscribing;



// WEBPACK FOOTER //
// ./src/author/components/Subscribing/Subscribing.js